import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { Skeleton } from "../../feedback/Skeleton";

export type StepProgressCardSkeletonProps = HTMLAttributes<HTMLDivElement> & {
  steps?: number;
  surface?: "card" | "plain";
};

export const StepProgressCardSkeleton = forwardRef<HTMLDivElement, StepProgressCardSkeletonProps>(({ className, steps = 4, surface = "plain", ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "bfrs-w-full bfrs-max-w-[425px]",
      surface === "card" && "bfrs-faded-card-border bfrs-rounded-xl bfrs-bg-[image:var(--bfrs-gradient-card)] bfrs-p-5 bfrs-shadow-card",
      className
    )}
    aria-hidden="true"
    {...props}
  >
    <Skeleton variant="text" className="bfrs-h-3 bfrs-w-36" />
    <Skeleton variant="text" className="bfrs-mt-2 bfrs-h-7 bfrs-w-72 bfrs-max-w-full" />
    <div className="bfrs-mt-[21px] bfrs-grid bfrs-gap-0">
      {Array.from({ length: steps }, (_, index) => (
        <div key={index} className="bfrs-grid bfrs-min-h-[35px] bfrs-grid-cols-[16px_minmax(0,1fr)] bfrs-gap-2">
          <Skeleton variant="avatar" className={cn("bfrs-mt-[3px] bfrs-size-2", index === 1 && "bfrs-mt-0 bfrs-size-4")} />
          <Skeleton variant="text" className="bfrs-h-4 bfrs-w-56" />
        </div>
      ))}
    </div>
  </div>
));

StepProgressCardSkeleton.displayName = "StepProgressCardSkeleton";
